import React from 'react';

export const STATUS_META = {
  sending: { label: 'Sending', tone: 'bg-zinc-100 text-zinc-600' },
  sent: { label: 'Sent', tone: 'bg-sky-50 text-sky-700' },
  delivered: { label: 'Delivered', tone: 'bg-emerald-50 text-emerald-700' },
  delayed: { label: 'Delayed', tone: 'bg-amber-50 text-amber-700' },
  bounced: { label: 'Bounced', tone: 'bg-red-50 text-red-700' },
  failed: { label: 'Failed', tone: 'bg-red-50 text-red-700' },
  suppressed: { label: 'Suppressed', tone: 'bg-red-50 text-red-700' },
  complained: { label: 'Marked as spam', tone: 'bg-red-50 text-red-700' },
};

export const EmailStatusBadge = ({ status, testId }) => {
  const m = STATUS_META[status] || { label: status, tone: 'bg-zinc-100 text-zinc-600' };
  return <span className={`inline-block text-[11px] font-semibold px-2 py-0.5 rounded-full ${m.tone}`} data-testid={testId}>{m.label}</span>;
};

export const AudienceBadge = ({ audience }) => (
  <span className={`inline-block text-[10px] font-bold uppercase tracking-wide px-1.5 py-0.5 rounded ${audience === 'internal' ? 'bg-zinc-800 text-white' : 'bg-orange-100 text-orange-800'}`}>
    {audience === 'internal' ? 'Team notification' : 'Customer email'}
  </span>
);

export const purposeLabel = (p) => (p || 'email').replace(/_/g, ' ').replace(/^\w/, (c) => c.toUpperCase());

export const fmtWhen = (iso) => (iso ? new Date(iso).toLocaleString('en-US', { timeZone: 'America/Los_Angeles', month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit' }) : '—');
